import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";

import { Link } from "react-router-dom";
import "./propertyList.css";
import { formatDate } from "../globalFunctions/globalFunctions";

const PropertyList = (props) => {
  const { properties, isLoading, fetchData, selectedListings, onHandleselectedList } = props;
  const [resetCount, setResetCount] = useState(0);

  const propertiesView = () => {
    return properties.data.map((property) => {
      const { id, userAgentID, listingID, address, cityName, sqFt, idxPropType, propStatus, bedrooms, listingPrice, state, updated_at } = property.property;

      return (
        <tr key={id}>
          <td style={{ width: "10px", paddingRight: "0" }}>
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                checked={selectedListings.some((item) => item.listingID === listingID)}
                onChange={(event) => onHandleselectedList(listingID, userAgentID, event)}
              />
              <label className="form-check-label"></label>
            </div>
          </td>
          <td>
            <div className="d-flex align-items-center gap-2">
              {property.images[0]?.full && (
                <div>
                  <img src={property.images[0].full} alt="" className="avatar-md rounded border border-light border-3" />
                </div>
              )}
              <div>
                <Link to={`/property-details/${listingID}`} className="text-dark fw-medium fs-15">
                  {address}, {cityName}, {state}
                </Link>
              </div>
            </div>
          </td>
          <td>{sqFt} sqft</td>
          <td>{listingPrice}</td>
          <td>{idxPropType}</td>
          <td style={{ width: "80px" }}>
            <span className="badge bg-success-subtle text-success py-1 px-2 fs-13">{propStatus}</span>
          </td>
          <td>
            <Icon icon="solar:bed-broken" className="align-middle fs-16"></Icon> {bedrooms}
          </td>
          <td>{state}</td>

          <td className="action-btns">
            {formatDate(updated_at)}
            {/* <div className="d-flex gap-1">
              <Link to={`/property-details/${listingID}`} className="btn btn-light btn-sm">
                <Icon icon="solar:eye-broken" className="align-middle fs-18"></Icon>
              </Link>
              <a href="#!" className="btn btn-soft-primary btn-sm">
                <Icon icon="solar:pen-2-broken" className="align-middle fs-18"></Icon>
              </a>
              <a href="#!" className="btn btn-soft-danger btn-sm">
                <Icon icon="solar:trash-bin-minimalistic-2-broken" className="align-middle fs-18"></Icon>
              </a>
            </div> */}
          </td>
        </tr>
      );
    });
  };

  const propertyLoadingView = () => {
    return (
      <tr className="loading-hover">
        <td className="property-loader preloader">
          <div class="loading">
            <div class="loading__letter">L</div>
            <div class="loading__letter">o</div>
            <div class="loading__letter">a</div>
            <div class="loading__letter">d</div>
            <div class="loading__letter">i</div>
            <div class="loading__letter">n</div>
            <div class="loading__letter">g</div>
            <div class="loading__letter">.</div>
            <div class="loading__letter">.</div>
            <div class="loading__letter">.</div>
          </div>
        </td>
      </tr>
    );
  };

  const noPropertyView = () => {
    return (
      <tr className="loading-hover">
        <td className="no-data-found">
          <Icon icon="solar:home-broken" className="fs-32 text-primary avatar-title"></Icon>
          No Properties Found
        </td>
      </tr>
    );
  };

  const renderView = () => {
    if (isLoading) {
      return propertyLoadingView();
    } else if (properties.status === "Not Found") {
      return noPropertyView();
    } else if (properties.status === "Success") {
      return propertiesView();
    }
  };

  useEffect(() => {
    if (resetCount > 0) {
      fetchData(1);
    }
  }, [resetCount]);

  return (
    <div className="row">
      <div className="col-xl-12">
        <div className="card">
          <div className="table-responsive">
            <table className="table align-middle text-nowrap table-hover table-centered property-table">
              <thead className="bg-light-subtle">
                <tr>
                  <th style={{ width: "10px" }}>
                    <div className="form-check">
                      <input type="checkbox" className="form-check-input" />
                      <label className="form-check-label"></label>
                    </div>
                  </th>
                  <th>Properties Photo & Location</th>
                  <th>Size</th>
                  <th>Price</th>
                  <th>Property Type</th>
                  <th style={{ width: "80px" }}>Property Status</th>
                  <th>Bedrooms</th>
                  <th>State</th>
                  <th>Created Date</th>
                </tr>
              </thead>
              <tbody>{renderView()}</tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyList;
